import { render, staticRenderFns } from "./page-element-footer-logo.vue?vue&type=template&id=0aba684d&scoped=true"
import script from "./page-element-footer-logo.vue?vue&type=script&lang=js"
export * from "./page-element-footer-logo.vue?vue&type=script&lang=js"
import style0 from "./page-element-footer-logo.vue?vue&type=style&index=0&id=0aba684d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba684d",
  null
  
)

export default component.exports